var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCommonIconSnsYoutubeLineWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.415 8.967c-.322-1.168-1.271-2.088-2.476-2.4C23.756 6 15 6 15 6s-8.755 0-10.938.567c-1.205.312-2.154 1.232-2.476 2.4C1 11.084 1 15.5 1 15.5s0 4.416.585 6.533c.322 1.168 1.27 2.088 2.476 2.4C6.244 25 15 25 15 25s8.756 0 10.94-.567c1.204-.312 2.153-1.232 2.475-2.4C29 19.916 29 15.5 29 15.5s0-4.416-.585-6.533",
    stroke: "#ECE0CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.698 11.8 6.38 2.744a.5.5 0 0 1 .05.894l-6.38 3.636A.5.5 0 0 1 12 18.64v-6.38a.5.5 0 0 1 .698-.46z",
    fill: "#ECE0CE"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonIconSnsYoutubeLineWhite);
export default __webpack_public_path__ + "static/media/common-icon-sns-youtube-line-white.c5a100c1fa63480df45421b26afbcf80.svg";
export { ForwardRef as ReactComponent };